export default __webpack_public_path__ + "static/media/traveling_white_lady.5abca2eb.jpg";